import { FormattedMessage } from 'react-intl';

import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

import { VideoCameraAddOutlined } from '@ant-design/icons';

// icons
const icons = { VideoCameraAddOutlined };

/** Read by the drawer's `SHOW_VIDEO_AI` gate, which drops this item alone rather than the whole group. */
export const OPTIMIZED_VIDEO_ITEM_ID = 'video-ai';

export const video: NavItemType = {
  id: 'video-menu',
  type: 'group',
  children: [
    {
      id: 'video',
      title: <FormattedMessage id="video-ai" />,
      type: 'collapse',
      icon: icons.VideoCameraAddOutlined,
      children: [
        {
          id: 'video-archetypes',
          title: <FormattedMessage id="video-archetypes" />,
          type: 'item',
          url: '/video-archetypes'
        },
        {
          id: OPTIMIZED_VIDEO_ITEM_ID,
          title: <FormattedMessage id="optimized-video" />,
          type: 'item',
          url: '/video-ai'
        }
      ]
    }
  ]
};
